import DOMPurify from "dompurify";
import { twMerge } from "tailwind-merge";
import type { TPlanButton } from "./types";
import { planButtonVariant } from "./variables";

export const PlanButton = ({
  id,
  active,
  description,
  title,
  onClick,
}: TPlanButton) => {
  const {
    wrapperClass,
    titleClass,
    textClass,
    wrapperBallClass,
    centerBallClass,
  } = planButtonVariant[active ? "active" : "inactive"];

  const PlanButtonElement = document.createElement("button");
  PlanButtonElement.id = id;
  PlanButtonElement.type = "button";
  PlanButtonElement.disabled = active;
  PlanButtonElement.className = twMerge(
    "w-full p-6 flex text-start cursor-pointer bg-white gap-2 transition duration-150",
    wrapperClass,
  );

  PlanButtonElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <div class="flex-1 flex flex-col gap-2">
            <h4 id="title-plan-button" class="${twMerge(
              "text-xl font-medium ",
              titleClass,
            )}">
                ${title}
            </h4>

            <p id="description-plan-button" class="${twMerge(
              "text-base font-normal ",
              textClass,
            )}">
                ${description}
            </p>
        </div>

        <div class="mr-2">
            <div id="wrapper-ball-plan-button" class="${twMerge(
              "w-4.5 h-4.5 flex items-center justify-center bg-white rounded-full",
              wrapperBallClass,
            )}">
                <div id="center-ball-plan-button" class="${twMerge(
                  "w-1.5 h-1.5 rounded-full",
                  centerBallClass,
                )}"></div>
            </div>
        </div>
    `);

  PlanButtonElement.addEventListener("click", (e) => onClick(e));

  return PlanButtonElement;
};
